import React from "react";
import { Field } from "redux-form";
import { required } from "../../../utils/formValidators";
import { renderRadioField } from "../../../utils/renderField";
import Show from "../../../utils/show.component";

const StylizedRadioGroup = (props) => {
  const omitFieldError = props.omitFieldError ? true : false;

  const isSelected = (thisFieldValue) => {
    return props.thisForm && props.thisForm.values[props.fieldGroupName] === thisFieldValue;
  };

  const styleSelected = (thisFieldValue) => {
    if (props.includeHighlighting) {
      return isSelected(thisFieldValue) ? "stylized-radio-selected" : "stylized-radio-unselected";
    }

    return "";
  };

  const determineCheckState = (thisFieldValue) => {
    const iconName =
      props.thisForm && props.thisForm.values[props.fieldGroupName] === thisFieldValue
        ? "check_circle"
        : "radio_button_unchecked";

    return (
      <i className="material-icons" style={{ alignSelf: "center", color: "#05588c" }}>
        {iconName}
      </i>
    );
  };

  const fieldError =
    props.thisForm &&
    props.thisForm.fields &&
    props.thisForm.fields[props.fieldGroupName] &&
    props.thisForm.fields[props.fieldGroupName].touched &&
    props.thisForm.syncErrors &&
    props.thisForm.syncErrors[props.fieldGroupName];

  const fieldErrorElement = omitFieldError ? null : (
    <span style={{ color: "red", fontStyle: "italic" }}>{fieldError}</span>
  );

  const radioElements = props.radioOptions.map((radio) => {
    return (
      <div
        className={`pr-3 border-radius-5 radio-focus ${styleSelected(radio.value)}`}
        onClick={() => {
          props.change(props.fieldGroupName, radio.value);
        }}
      >
        <div class="auth-radio-question">
          {determineCheckState(radio.value)}
          <Field
            label={radio.label}
            id={radio.id}
            name={props.fieldGroupName}
            component={renderRadioField}
            type="radio"
            value={radio.value}
            validate={[required]}
            omitErrors={true}
            containerClassNames="ml-4 w-100"
            e2eId={radio.id + "e2eId"}
          />
        </div>
      </div>
    );
  });

  return (
    <div>
      <div className="pt-4 f18 bold" style={{ display: props.title ? "" : "none" }}>
        {props.title}
      </div>
      <div className="mb-4" style={{ display: props.subtitle ? "" : "none" }}>
        {props.subtitle}
      </div>
      {radioElements}
      {fieldErrorElement}
    </div>
  );
};

export default StylizedRadioGroup;



// WEBPACK FOOTER //
// ./src/components/authenticated-payments/misc/stylized-radio-group.component.js